export default __webpack_public_path__ + "static/media/031-spring onion.86b6da1e.svg";